import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";
const urlPackageDetail = "PackageDetail";

export const newPaqueteDetalle = async ({ IdPaquete, Incluye, NoIncluye, Itinerario}) => {
    let payload = JSON.stringify({
        IdPaquete,
        Incluye,
        NoIncluye,
        Itinerario
    })

    return await axios.post(`${APIURL}/${urlPackageDetail}/Add`, payload, {
        headers: getCabecera(),
    }).then(Resposne => {
        return Resposne.data
    }).catch(Error => {
        return getError(Error)
    });
};

export const updatePaqueteDetalle = async ({IdPaquete, Incluye, NoIncluye, Itinerario}) => {
    let payload = JSON.stringify({
        Incluye, 
        NoIncluye, 
        Itinerario
    })
    return await axios.put(`${APIURL}/${urlPackageDetail}/${IdPaquete}`, payload , {
        headers: getCabecera(),
    }).then(Resposne => {
        return Resposne.data
    }).catch(Error => {
        return getError(Error)
    });
};

export const getPaqueteDetalleByIdPaquete = async ({ IdPaquete }) => {
    return await axios.get(`${APIURL}/${urlPackageDetail}/${IdPaquete}`,
    {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return {}
    })
};
